import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ModalService } from '../../../services/modalService/modal.service';
import { UserComponent } from '../zoomView/users/users.component';
import _ from 'lodash';
import { ModalHelper } from '../../../services/modalService/modal.helper';
import { UtilsService } from '../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css', '../myreports.component.css']
})
export class UsersComponent implements OnInit {
  ruid: string;
  
  users: any = [];
  mutatedUsers = [];

  totalUsers = 0;
  count = 0;
  isLicense: boolean;
  isLoggedIn = false;
  currentUser: any;

    columns = [
        {
            name: 'user',
            desc: this.translate.instant('reports.user.user'),
            subName: 'workstation',
            tooltip: '',
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'sessions',
            desc: this.translate.instant('reports.user.session'),
            tooltip: this.translate.instant('reports.user.sessionTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        },
        {
            name: 'duration',
            desc: this.translate.instant('reports.user.total'),
            tooltip: this.translate.instant('reports.user.totalTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.durationTableSorterFactory
        },
        {
            name: 'averageSession',
            desc: this.translate.instant('reports.user.avg'),
            tooltip: this.translate.instant('reports.user.avgTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.durationTableSorterFactory
        },
        {
            name: 'denials',
            desc: this.translate.instant('reports.user.denials'),
            tooltip: this.translate.instant('reports.user.denailsTooltip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        },
        {
            name: 'denialRate',
            desc: this.translate.instant('reports.user.denialRate'),
            tooltip: this.translate.instant('reports.user.denailRateTootlip'),
            sort: 'asc',
            isCurrent: false,
            sorter: this.utilService.numberStringTableSorterFactory
        }
    ];

    limitedColumns = [
        this.columns[0],
        this.columns[1],
        this.columns[2],
        this.columns[4]
    ];

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private loginService: LoginService,
        private notifications: NotificationsService,
        private modalHelper: ModalHelper,
        private modalService: ModalService,
        private utilService: UtilsService,
        private translate: TranslateService
    ) {}
    
    trackBy(index, item){
        if(!item) {
            return null;
        }
        return index;
     }
  ngOnInit() {
    this.loginService.isLoggedIn()
      .subscribe((currentUser) => {
          this.currentUser = currentUser;
          this.isLoggedIn = this.currentUser.isLoggedIn;
      });
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getUsers(this.ruid)
                .subscribe((usersRes) => {
                  this.totalUsers = usersRes.usersTotalNr;
                  this.count = usersRes.usersNr;
                  this.users = usersRes.users;
                  //this.mutatedUsers = mutateDataSet(usersRes.users.slice());
                }, usersErr => {
                    this.notifications.error(
                        this.translate.instant('common.error'),
                        this.apiService.getMessageFromError(
                            usersErr,
                            this.translate.instant(
                                'reports.user.fail'
                            )
                        )
                    );
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, 'Ruid is invalid, Please try again'));
          });
      }
    });
  }

  loginPrompt() {
    this.modalHelper.openLogin({});
  }

  zoomView() {
    this.modalService.open(UserComponent, {
      title: 'Users',
      data: {
        totalUsers: this.totalUsers,
        count: this.count,
        users: this.users,
        currentUser: this.currentUser,
        ruid: this.ruid
      }
    }).subscribe(model => {
    });
  }

  fullReport(): boolean {
      return (this.currentUser && this.currentUser.paid) || this.ruid == 'demo';
  }

  sortCols(name) {
    const column = _.find(this.columns, {name: name});
    _.each(this.columns, function (column) {
      column.isCurrent = false;
    });
    column.isCurrent = true;

    const sorter = column.sorter ? column.sorter(name) : name;
    const order = column.sort;

    this.users = _.orderBy(this.users, sorter, order);

    if(this.fullReport()) {
        let subsorter = sorter;
        if(column.subName) {
            subsorter = column.sorter ? column.sorter(column.subName) : column.subName;
        }
        _.each(this.users, function (user) {
            if(user.workstations.length > 1){
                user.workstations = _.orderBy(user.workstations, sorter, order);
            }
        });
    }

    if (order === 'asc') {
      column.sort = 'desc';
    } else {
      column.sort = 'asc';
    }
    
    // this.users = users.slice();

    //this.mutatedUsers = mutateDataSet(this.users.slice());

    // console.log(users);

    // users.forEach((element, i) => {
    //   if(element.workstations && element.workstations.length > 1) {
    //     element.workstations.forEach((element2, i2) => {
    //       if(i > 0) {
    //         console.log('iterate')
    //         users.splice(i + i2, 0, element2)
    //       }
    //     });
    //   }
    // });


    // for(let i = 0; i < users.length; i++) {
    //   if(Array.isArray(users[i].workstations) && users[i].workstations.length > 1) {
    //     let elementsInserted = 0;
    //     users[i].workstations.forEach((element2, i2) => {
    //       if(i2 > 0) {
    //         console.log('iterate')
    //         element2.isChild = true;
    //         // console.log(element2)
    //         users.splice(i + i2, 0, element2)
            
    //         elementsInserted++;
    //       }
    //     });
    //     i = i + elementsInserted;
    //   }
    // }
    // console.log(users);
    // users.forEach(element => {
    //   if(element.isChild){
    //     console.log(element)      }
    // });

    // users = null;
  }

  sortingStyle(column){
      return {'sorting-up': column.isCurrent && column.sort === 'asc', 'sorting-down': column.isCurrent && column.sort === 'desc'}
  }

}

function mutateDataSet(users) {
  for(let i = 0; i < users.length; i++) {
    if(Array.isArray(users[i].workstations) && users[i].workstations.length > 1) {
      let elementsInserted = 0;
      users[i].workstations.forEach((element2, i2) => {
        if(i2 > 0) {
          // console.log('iterate')
          element2.isChild = true;
          // console.log(element2)
          users.splice(i + i2, 0, element2)
          
          elementsInserted++;
        }
      });
      i = i + elementsInserted;
    }
  }
  return users;
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/users/users.component.ts